// src/components/MatrixPartnerLogin.jsx
import React, { useState, useRef, useEffect } from 'react';
import { Form, Input, Button, Icon, message, Row, Col, Typography } from 'antd';
import axios from 'axios';
import './PartnerLoginPage.css';
import { API_PATH } from '../../constants/ApiPath'
import CircularProgress from "components/CircularProgress/index";
import OffersCarousel from "../../components/OffersCarousel";

const FormItem = Form.Item;
const { Text, Title } = Typography;

const headers = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
}

const MatrixPartnerLogin = (props) => {
  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [passphraseSent, setPassphraseSent] = useState(false);
  const [passphrase, setPassphrase] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [useEmail, setUseEmail] = useState(false);
  const [emailMethod, setEmailMethod] = useState(''); // 'password' or 'passphrase'
  const [noMatch, setNoMatch] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [lastSentTime, setLastSentTime] = useState(null);
  const [emailtosent, setEmail] = useState('')
  const [galleryData, setGalleryData] = useState([]);
  const [carouselSpeed, setCarouselSpeed] = useState(3000);
  const passphraseInputRef = useRef(null);

  const fetchCompanyName = (phone) => {

    setLoading(true);

    const endpoint = `/partner/fetch-partner-whatsapp/?whatsapp_number=${phone}`
    axios.get(API_PATH.concat(endpoint), { headers })
      .then(res => {
        console.log(res.status, 'status')
        if (res.status === 200) {
          setCompanyName(res?.data?.company_name);
          setNoMatch(false);

        } else {
          setCompanyName('');
          setNoMatch(true);
          message.warning('Phone No. not Registered with any Company!');
        }
      }).catch(error => {
        const status = error?.response?.status;
        if (status === 404)
          message.warning('WhatsApp No. not Registered!');
        else if (status === 403)
          message.warning('This WhatsApp number is not linked to a partner login account.');
        else
          message.error('Failed to fetch company name');
        setCompanyName('');
        setNoMatch(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }
  const fetchCompanyNameByEmail = (e) => {
    const email = e.target.value
    setLoading(true);

    const endpoint = `/partner/fetch-partner-by-email/?email=${email}`
    axios.get(API_PATH.concat(endpoint), { headers })
      .then(res => {
        console.log(res.data.status, 'status666', email)
        if (res.data.status === 200) {
          setCompanyName(res?.data?.company_name);
          setEmail(email)
          setNoMatch(false);

        } else {
          setCompanyName('');
          setNoMatch(true);
          setEmail('')
          message.warning('Email not Registered!');
        }
      }).catch(error => {
        if (error.response.status === 404)
          message.warning('Email not Registered!');
        else
          message.error('Failed to fetch company name');
        setEmail('')
        setCompanyName('');
        setNoMatch(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const sendPassphrase = async (to, type = 'whatsapp') => {

    setLoading(true);
    let endpoint, data
    if (type === 'whatsapp'){
      data = {
        phone: to
      }
      endpoint = `/partner/send-passphrase-whatsapp/`
    }
      
    else
    {
      data = {
        email: to
      }
      endpoint = `/partner/email-passphrase/`
    }
      

    axios.post(API_PATH.concat(endpoint), data, { headers })
      .then(res => {
        if (res.status === 200) {
          message.success(`Passphrase sent to your ${type === 'whatsapp' ? 'WhatsApp number' : 'email'}`);
          setPassphraseSent(true);
          setLastSentTime(Date.now());
          setResendDisabled(true);
          if (passphraseInputRef.current) {
            passphraseInputRef.current.focus(); // Move focus to passphrase field
          }
          setTimeout(() => setResendDisabled(false), 60000); // 1-minute cooldown


        } else {
          setPassphraseSent(false);
          message.warning(res.data.message)
        }
      }).catch(error => {
        message.error('Failed to send PhassPhrase! Try again.');
        setPassphraseSent(true);
      })
      .finally(() => {
        setLoading(false);
      });

  };

  const handlePhoneBlur = (e) => {
    const phone = e.target.value;
    if (phone && /^[0-9]{10}$/.test(phone)) {
      fetchCompanyName(phone);
    } else {
      setCompanyName('');
      setNoMatch(false);
    }
  };

  // Gallery helpers (reuse caching approach)
  const loadGallery = () => {
    const cacheKey = 'gallery_cache_partner';
    const cachedData = localStorage.getItem(cacheKey);
    if (cachedData) {
      try {
        const parsed = JSON.parse(cachedData);
        if (parsed.images && parsed.images.length > 0) {
          setGalleryData(parsed.images);
          setCarouselSpeed(parsed.speed || 3000);
        }
        // Check for updates in background
        checkGalleryUpdate(parsed.updated_at);
        return;
      } catch (e) {
        console.error('Error parsing cached gallery data:', e);
      }
    }
    fetchGallery();
  };

  const checkGalleryUpdate = (cachedUpdateDate) => {
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };
    const endpoint = '/management/get-gallery/?portal_type=partner';

    axios.get(API_PATH.concat(endpoint), { headers })
      .then(res => {
        if (res.data && res.data.length > 0) {
          const apiUpdateDate = res.data[0].updated_at;
          const cachedDate = new Date(cachedUpdateDate);
          const apiDate = new Date(apiUpdateDate);
          if (apiDate > cachedDate) {
            saveGalleryToCache(res.data[0]);
            if (res.data[0].images && res.data[0].images.length > 0) {
              const sortedImages = res.data[0].images.sort((a, b) => a.order - b.order);
              setGalleryData(sortedImages);
              setCarouselSpeed(res.data[0].speed || 3000);
            }
          }
        }
      })
      .catch(error => console.error('Failed to check gallery update:', error));
  };

  const fetchGallery = () => {
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    };
    const endpoint = '/management/get-gallery/?portal_type=partner';

    axios.get(API_PATH.concat(endpoint), { headers })
      .then(res => {
        if (res.data && res.data.length > 0 && res.data[0].images && res.data[0].images.length > 0) {
          const sortedImages = res.data[0].images.sort((a, b) => a.order - b.order);
          saveGalleryToCache(res.data[0]);
          setGalleryData(sortedImages);
          setCarouselSpeed(res.data[0].speed || 3000);
        } else {
          console.log('No images found in gallery response');
        }
      })
      .catch(error => console.error('Failed to fetch gallery:', error));
  };

  const saveGalleryToCache = (galleryData) => {
    const cacheKey = 'gallery_cache_partner';
    const cacheData = {
      images: galleryData.images.sort((a, b) => a.order - b.order),
      speed: galleryData.speed || 3000,
      updated_at: galleryData.updated_at
    };
    localStorage.setItem(cacheKey, JSON.stringify(cacheData));
  };

  // Load gallery on mount
  useEffect(() => {
    loadGallery();
  }, []);

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    props.form.validateFields(['mobile'], async (err, values) => {
      if (!err && companyName) {
        await sendPassphrase(values.mobile, 'whatsapp');
      }
    });
  };

  const handleEmailPassphraseSubmit = (e) => {
    e.preventDefault();
    props.form.validateFields(['email'], async (err, values) => {
      if (!err) {
        await sendPassphrase(values.email, 'email');
      }
    });
  };

  const handlePassphraseSubmit = (e) => {
    const { dispatch } = props
    e.preventDefault();
    setLoading(true);
    props.form.validateFields((err, values) => {
      if (!err) {
        let user, endpoint
        if(emailMethod && useEmail){
          user = {
            email: values.email,
            passphrase: values.passphrase
          };
          endpoint =`/partner/verify-passphrase/`
        }else{
          user = {
            whatsapp_number: values.mobile,
            passphrase: values.passphrase
          };
           endpoint = '/partner/whatsapp-passphrase/'
        }
       
        
        axios.post(API_PATH.concat(endpoint), user, { headers })
          .then(res => {
            console.log(res.data.status, 'sttsts')
            if (res?.data?.status === 200) {
              localStorage.setItem('token', res.data['token']);
              localStorage.setItem('uuid', res.data['uuid']);
              localStorage.setItem('user_uuid', res.data.uuid)
              localStorage.setItem('ticket_role', res.data['ticket_role']);
              localStorage.setItem('all_roles', res.data['all_roles']);
              localStorage.setItem('user_role', res.data['user_role']);
              if (res.data['user_role'] === 'partner') {
                localStorage.setItem('loged_in_to', "orion")
                props.history.push('/detail/'.concat(res.data['uuid']));
                message.success('Login successful!');
                setIsLoggedIn(true);
                props.form.resetFields();
                setPassphrase('');
                setPassphraseSent(false);
                setCompanyName('');
                setUseEmail(false);
                setEmailMethod('');
                setNoMatch(false);
              }
            } else {
              message.error('Incorrect Passphrase!');
              setResendDisabled(false); // Enable resend on incorrect passphrase
            }

          })
          .catch(error => {
            console.log(error);
            message.error("Error Login!")

          }).finally(() => {
            setLoading(false);
          });

      } else {
        setLoading(false);
      }
    });
  };
  const sendPassphraseByEmail = (e) => {
    setEmailMethod('passphrase')         
    sendPassphrase(emailtosent, 'email');

  }

  const handleResend = () => {
    const values = props.form.getFieldsValue();
    const target = useEmail ? values.email : values.mobile;
    sendPassphrase(target, useEmail ? 'email' : 'whatsapp');
  };

  const { getFieldDecorator } = props.form;



  return (
    <div className="gx-app-login-wrap modern-signin-wrapper">
      <div className="gx-app-login-container modern-signin-container">
        <Row type="flex" align="middle" className="gx-app-login-main-content modern-signin-main" gutter={0}>
          <Col xl={12} lg={12} md={12} sm={24} xs={24} className="emptySpacing modern-signin-left">
            <div 
              className="modern-signin-left-bg"
              style={{ backgroundColor: '#FAFAFA' }}
            >
              <div className="modern-signin-left-content">
                <OffersCarousel
                  images={galleryData || []}
                  speed={carouselSpeed || 5000}
                  fallbackSrc={require('assets/images/Service_Technicians_at_Work.png')}
                />
              </div>
            </div>
          </Col>
          <Col xl={12} lg={12} md={12} sm={24} xs={24} className="emptySpacing modern-signin-right">
            <div className="modern-signin-form-container">
              <div className="modern-signin-header">
                <div className="modern-signin-header-left">
                  <Title level={2} className="modern-signin-header-title">Matrix</Title>
                  <Text className="modern-signin-header-subtitle">Field Services Management</Text>
                </div>
                <div className="modern-signin-header-right">
                  <img src={require('assets/images/LogoUniserved.png')} alt='Logo' className="modern-signin-header-logo" />
                </div>
              </div>
              <div className="modern-signin-form-content">
                <Text className="modern-signin-portal-label">Partner Login</Text>
                <Title level={1} className="modern-signin-form-title" style={{ color: '#262626' }}>Sign In</Title>
                <Text className="modern-signin-form-text">
                  {passphraseSent 
                    ? 'Enter the passphrase sent to your WhatsApp number or email to continue.'
                    : 'Enter your WhatsApp number or email to receive a passphrase for secure login.'}
                </Text>
                <Form 
                  layout="vertical"
                  onSubmit={
                    passphraseSent
                      ? handlePassphraseSubmit
                      : useEmail && emailMethod === 'passphrase'
                        ? handleEmailPassphraseSubmit
                        : handleLoginSubmit
                  }
                  className="modern-signin-form"
                  autoComplete="off"
                >
                  {companyName && (
                    <FormItem 
                      label="Company Name"
                      className="modern-signin-form-item"
                      required={false}
                    >
                      <Text strong style={{ fontSize: '16px', color: '#333' }}>{companyName}</Text>
                    </FormItem>
                  )}
                  
                  {!useEmail ? (
                    <>
                      <FormItem
                        label="* WhatsApp Number:"
                        className="modern-signin-form-item"
                        required={false}
                      >
                        {getFieldDecorator('mobile', {
                          rules: [
                            { required: true, message: 'Please enter your WhatsApp number!' },
                            { pattern: /^[0-9]{10}$/, message: 'Enter a valid 10-digit number!' },
                          ],
                        })(
                          <Input
                            prefix={<Icon type="phone" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="Enter 10-digit WhatsApp number"
                            className="modern-signin-input"
                            maxLength={10}
                            onBlur={handlePhoneBlur}
                            disabled={passphraseSent}
                            autoComplete="off"
                            name="mobile-disabled"
                          />
                        )}
                      </FormItem>

                      {noMatch && (
                        <div className="modern-signin-forgot">
                          <span 
                            className="modern-signin-forgot-link" 
                            onClick={() => setUseEmail(true)}
                            style={{ cursor: 'pointer' }}
                          >
                            Login with email
                          </span>
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <FormItem
                        label="* Email:"
                        className="modern-signin-form-item"
                        required={false}
                      >
                        {getFieldDecorator('email', {
                          rules: [
                            { required: true, message: 'Please enter your email!' },
                            { type: 'email', message: 'Enter a valid email!' },
                          ],
                        })(
                          <Input
                            prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder="Enter your email"
                            className="modern-signin-input"
                            disabled={passphraseSent}
                            onBlur={fetchCompanyNameByEmail}
                            autoComplete="off"
                            name="email-disabled"
                          />
                        )}
                      </FormItem>
                      {!emailMethod && (
                        <FormItem className="modern-signin-form-item">
                          <div className="email-options">
                            <Button onClick={() => props.history.push('/signin')} className="modern-signin-submit-btn" style={{ background: '#999', border: 'none' }}>
                              Use Password
                            </Button>
                            <Button 
                              onClick={sendPassphraseByEmail} 
                              type="primary" 
                              className="modern-signin-submit-btn" 
                              disabled={!companyName}
                            >
                              Use Passphrase
                            </Button>
                          </div>
                        </FormItem>
                      )}
                    </>
                  )}

                  {(passphraseSent || (useEmail && emailMethod === 'passphrase' && passphraseSent)) && (
                    <FormItem
                      label="* Passphrase:"
                      className="modern-signin-form-item"
                      required={false}
                    >
                      {getFieldDecorator('passphrase', {
                        rules: [
                          { required: true, message: 'Please enter your Passphrase!' },
                        ],
                      })(
                        <Input
                          prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                          placeholder="Enter passphrase"
                          className="modern-signin-input"
                          value={passphrase}
                          onChange={(e) => setPassphrase(e.target.value)}
                          ref={passphraseInputRef}
                          autoComplete="off"
                          name="passphrase-disabled"
                        />
                      )}
                      <div className="modern-signin-forgot">
                        <Button 
                          type="link"
                          onClick={handleResend}
                          disabled={resendDisabled}
                          className="modern-signin-forgot-link"
                          style={{ padding: 0, height: 'auto' }}
                        >
                          Resend Passphrase
                        </Button>
                      </div>
                    </FormItem>
                  )}

                  <FormItem className="modern-signin-submit-item">
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                      className="modern-signin-submit-btn"
                      disabled={
                        (!useEmail && !companyName && !passphraseSent) ||
                        (useEmail && !emailMethod)
                      }
                      block
                    >
                      <Icon type={passphraseSent ? "lock" : "login"} />
                      {passphraseSent ? 'Verify Passphrase' : 'Login'}
                    </Button>
                  </FormItem>
                </Form>
              </div>
            </div>
            {loading ?
              <div className="gx-loader-view">
                <CircularProgress />
              </div> : null}
          </Col>
        </Row>
      </div>
    </div>
  );
};

const PartnerLoginPage = Form.create()(MatrixPartnerLogin);

export default PartnerLoginPage;